import { NextApiRequest } from 'next';
import { ParsedUrlQuery } from 'node:querystring';

import { RestApiError } from 'services/api/restful/errors';

const errorIntlIdLookup = {
  AccountExists: 'api.error.account.exists',
  SaudiRewardsRequestError: 'api.error.saudi.rewards',
};

const getAccountErrorCode = (body: unknown): string | undefined => {
  if (body == null || typeof body !== 'object') return undefined;

  const record = body as Record<string, unknown>;
  if (typeof record.errorCode === 'string') return record.errorCode;
  if (typeof record.errorType === 'string') return record.errorType;
  if (typeof record.code === 'string') return record.code;

  return undefined;
};

export const getIntlIdFromAccountApiError = (error: unknown) => {
  if (!(error instanceof RestApiError)) return undefined;

  const code = getAccountErrorCode(error.body);
  if (!code) return undefined;

  return errorIntlIdLookup[code as keyof typeof errorIntlIdLookup];
};

export const queryParam = (
  query: ParsedUrlQuery,
  key: string,
  fallback: string | undefined = '',
): string => (typeof query[key] === 'string' ? query[key] : fallback);

// Read off the request, not an env var, so preview deploys work too.
export const getRequestOrigin = (req: NextApiRequest) => {
  const forwarded = req.headers['x-forwarded-proto'];

  // The proxy sets the scheme. Without it, only local dev is left.
  const protocol =
    (Array.isArray(forwarded) ? forwarded[0] : forwarded) ??
    (req.headers.host?.startsWith('localhost') ? 'http' : 'https');

  return `${protocol}://${req.headers.host}`;
};
